interface EzoicStandalone {
  define: (id: number) => void;
  enabled: boolean;
  enable: () => void;
  display: () => void;
}

declare global {
  interface Window {
    ezstandalone: EzoicStandalone;
  }
}

export const AD_PLACEMENTS = {
  CONTENT_TOP: 620,
  CONTENT_MIDDLE: 621,
  CONTENT_BOTTOM: 622,
  SIDEBAR_TOP: 623,
  SIDEBAR_MIDDLE: 624,
  SIDEBAR_BOTTOM: 625
} as const;

export function insertAdsInContent(htmlContent: string) {
  const div = document.createElement('div');
  div.innerHTML = htmlContent;

  // Insert top ad after first paragraph
  const firstP = div.querySelector('p');
  if (firstP) {
    const topAd = createAdPlaceholder(AD_PLACEMENTS.CONTENT_TOP);
    firstP.parentNode?.insertBefore(topAd, firstP.nextSibling);
  }

  // Insert ads before H2s
  const h2Elements = div.querySelectorAll('h2');
  for (let i = 1; i < h2Elements.length; i++) {
    const middleAd = createAdPlaceholder(AD_PLACEMENTS.CONTENT_MIDDLE);
    h2Elements[i].parentNode?.insertBefore(middleAd, h2Elements[i]);
  }

  // Insert bottom ad before last paragraph
  const paragraphs = div.querySelectorAll('p');
  if (paragraphs.length > 0) {
    const lastP = paragraphs[paragraphs.length - 1];
    const bottomAd = createAdPlaceholder(AD_PLACEMENTS.CONTENT_BOTTOM);
    lastP.parentNode?.insertBefore(bottomAd, lastP);
  }

  return div.innerHTML;
}

export function createAdPlaceholder(id: number) {
  const div = document.createElement('div');
  div.id = `ezoic-pub-ad-placeholder-${id}`;
  div.className = 'ezoic-ad';
  return div;
}

export function initializeEzoic() {
  return new Promise<void>((resolve, reject) => {
    const maxAttempts = 5;
    let attempts = 0;

    const tryInitialize = () => {
      if (window.ezstandalone) {
        try {
          // Define all ad placements
          Object.values(AD_PLACEMENTS).forEach(id => {
            window.ezstandalone.define(id);
          });

          if (!window.ezstandalone.enabled) {
            window.ezstandalone.enable();
          }
          window.ezstandalone.display();
          resolve();
        } catch (error) {
          reject(error);
        }
      } else if (attempts < maxAttempts) {
        attempts++;
        setTimeout(tryInitialize, 1000);
      } else {
        reject(new Error('Failed to initialize Ezoic after multiple attempts'));
      }
    };

    tryInitialize();
  });
}
